import { createIsomorphicFn } from "@tanstack/react-start";

export function isPreviewSearchEnabled(value: unknown): boolean {
	return value === true || (typeof value === "string" && value.trim().toLowerCase() === "true");
}

function readPreviewContext(url: URL) {
	const enabled = isPreviewSearchEnabled(url.searchParams.get("preview"));
	const tokens = url.searchParams.getAll("token");
	const token = enabled && tokens.length === 1 && tokens[0].length <= 4096 && /^[A-Za-z0-9_-]+$/.test(tokens[0])
		? tokens[0]
		: undefined;
	return { enabled, token };
}

const getRequestPreviewContext = createIsomorphicFn()
	.server(async () => {
		const { getRequest, getRequestUrl } = await import("@tanstack/react-start/server");
		const request = getRequest();
		const url = getRequestUrl();
		if (request.method === "POST" && url.pathname.startsWith("/_server/")) {
			const referer = request.headers.get("referer");
			if (referer) {
				try {
					const pageUrl = new URL(referer);
					if (pageUrl.origin === url.origin) return readPreviewContext(pageUrl);
				} catch {
					return { enabled: false, token: undefined };
				}
			}
		}
		return readPreviewContext(url);
	})
	.client(() => readPreviewContext(new URL(window.location.href)));

export const getRequestPreviewMode = async () => (await getRequestPreviewContext()).enabled;
export const getRequestPreviewToken = async () => (await getRequestPreviewContext()).token;